export default __webpack_public_path__ + "e3fac1217c0201c5caedddf08f3cb205.png";